const purchaseHistoryHR = {
    "view": {
        "table": {
            "title": "Vaša povijest kupnje",
            "column": {
                "amount": "Iznos",
                "description": "Opis",
                "credits_balance": "Stanje kredita",
                "tokens_balance": "Stanje tokena",
                "date_of_purchase": "Datum kupnje",
                "receipt": "Račun"
            },
            "placeholder": {
                "search": "Pretraži..."
            },
            "button": {
                "view": "Pogledaj",
                "export_csv": "Izvezi CSV"
            }
        }
    }
};

export default purchaseHistoryHR;